import { useState } from "react";

import { useLocalStorage } from "lib/hooks/useLocalStorage";
import { useIsLaptopLgUp } from "lib/providers/Responsive";

/**
 * Whether a search page is showing its filters.
 *
 * Remembered per page, because the answer differs by page: you might keep notice filters
 * beside you and spend filters out of the way. Only the inline panel is remembered —
 * below laptop-lg the filters are a drawer over the results, and a drawer that reopened
 * itself would be covering the results every time you arrived.
 */
export function useFilterPanelOpen(storageKey: string): [boolean, (open: boolean) => void] {
  const inlineFilters = useIsLaptopLgUp();
  const [inlineOpen, setInlineOpen] = useLocalStorage<boolean>(
    `search-filters-open:${storageKey}`,
    true,
  );
  const [drawerOpen, setDrawerOpen] = useState(false);

  return inlineFilters ? [inlineOpen, setInlineOpen] : [drawerOpen, setDrawerOpen];
}
